import { AccessControlProvider } from '@refinedev/core';

type Permission = string; // Format: "resource:action"

interface AdminUser {
  permissions: Permission[];
  role: {
    type: string;
  };
}

export const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action, params: _params }) => {
    const userStr = localStorage.getItem('admin_user');

    if (!userStr) {
      return { can: false };
    }

    const user: AdminUser = JSON.parse(userStr);

    // Check read-only modules (applies to all roles including super_admin)
    const writeActions = ['create', 'edit', 'delete', 'ban', 'grant_item'];
    if (resource && action && writeActions.includes(action)) {
      const readonlyModules: Record<string, boolean> = JSON.parse(
        localStorage.getItem('admin_readonly_modules') || '{}'
      );
      if (readonlyModules[resource]) {
        return {
          can: false,
          reason: `${resource} is in read-only mode`,
        };
      }
    }

    // Super admin has full access
    if (user.role.type === 'super_admin') {
      return { can: true };
    }

    // Check if user has the required permission
    const requiredPermission = `${resource}:${action}`;
    const hasPermission = user.permissions.includes(requiredPermission);

    // Also check for wildcard permissions
    const hasWildcard = user.permissions.some((p) => {
      const [pResource, pAction] = p.split(':');
      return (
        (pResource === resource && pAction === '*') || (pResource === '*' && pAction === action)
      );
    });

    return {
      can: hasPermission || hasWildcard,
      reason: hasPermission || hasWildcard ? undefined : 'Insufficient permissions',
    };
  },

  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: true,
    },
  },
};
